import { z } from "zod";

const quoteIdSchema = z.number().int().positive();

export const bulkTenderRequestSchema = z.object({
	quoteIds: z.array(quoteIdSchema).min(1),
});

export const bulkTenderedItemResultSchema = z.object({
	quoteId: quoteIdSchema,
	status: z.literal("tendered"),
	poNumber: z.number().int().positive(),
	reasonCode: z.null(),
	reason: z.null(),
});

const failedItemResultSchema = z.object({
	quoteId: quoteIdSchema,
	status: z.literal("failed"),
	poNumber: z.null(),
	reasonCode: z.string().min(1),
	reason: z.string().min(1),
});

export const bulkTenderItemResultSchema = z.discriminatedUnion("status", [
	bulkTenderedItemResultSchema,
	failedItemResultSchema,
]);

export const bulkTenderResponseSchema = z.object({
	bulkTenderId: z.string().uuid(),
	results: z.array(bulkTenderItemResultSchema).min(1),
});

export const bulkTenderNotificationTargetSchema = z.object({
	quoteId: quoteIdSchema,
	customerId: z.number().int().positive().nullable(),
});

export type BulkTenderRequest = z.infer<typeof bulkTenderRequestSchema>;
export type BulkTenderItemResult = z.infer<typeof bulkTenderItemResultSchema>;
export type BulkTenderResponse = z.infer<typeof bulkTenderResponseSchema>;
export type BulkTenderNotificationTarget = z.infer<
	typeof bulkTenderNotificationTargetSchema
>;
